import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  PARTNER: {
    id: 'Partner.partner',
    defaultMessage: 'Partner',
    description: '[Type: Label][Vis.: low] - Partner link in main navigation',
  },
});

const Partner = () => (
  <MainNavButton
    href="https://www.surveymonkey.com/mp/partner-program/"
    label={t(COPY.PARTNER)}
    navItem="partner"
  />
);

export default Partner;
export { Partner };
